import Vue from 'vue'
import VueAxios from 'vue-axios'
import {VueAuthenticate} from 'vue-authenticate'
import axios from 'axios';
import VueLocalStorage from "vue-localstorage"
import StoreService from "./store.service"

Vue.use(VueAxios, axios)

// const vueAuth = new VueAuthenticate(Vue.prototype.$http,
//   {
//     baseUrl: 'https://www.asspm.fr/app', // Your API domain
//     providers: {
//       facebook: {
//         clientId: '2473481466216139'
//         //clientId: process.env.VUE_APP_FB_APP_ID
//       }
//     }
//   }
// )

Vue.use(VueLocalStorage, {
  name: 'context',
  bind: true //created computed members from your variable declarations
})

const UserService = {

  _admins: [],

  signout() {
    Vue.context.set('auth', null);
  },

  signin: async function (email) {
    if (!_.isEmpty(email) && _.includes(this._admins, email)) {
      Vue.context.set('auth', {email})
    }
    // return vueAuth.authenticate(provider).then(result => {
    //   console.log(result)
    //   const access_token = _.get(result, "data.access_token")
    //   return axios.get(
    //     `https://graph.facebook.com/me?fields=name,gender,location,picture,email&access_token=${access_token}`,
    //     {'Headers': 'Content-type:application/x-www-form-urlencoded'}
    //   ).then(result => {
    //     console.log(result.data)
    //     Vue.context.set('auth', result.data)
    //   })
    //     .catch(e => {
    //       console.error(e)
    //     });
    // })
  },

  init() {
    return this.getAdmins()
  },

  getAdmins() {
    return StoreService.store("admin").all()
      .then(admins => this._admins = _.map(admins, "email"))
  },

  isAdmin() {
    const auth = Vue.context.get('auth')
    const email = _.get(auth, "email")
    const isAdmin = email && email.length
    return isAdmin
  },

  isAuth() {
    const auth = Vue.context.get('auth')
    return !_.isNil(auth) && !_.isEmpty(_.get(auth, "email"))
  },

  user() {
    return Vue.context.get('auth');
  }

}

export default UserService

export {UserService}